/**
 * Arquivo: src/components/DashboardDueSummary.tsx
 * Versão: 5.6.7
 * Descrição: Resumo compacto de compromissos do Dashboard mobile/PWA.
 */
import { CalendarClock, ChevronRight, CircleAlert } from 'lucide-react'

type ItemResumo = {
  tipo: 'overdue' | 'today' | 'next'
  titulo: string
  apoio: string
  valor: number
  onClick: () => void
}

type Props = {
  atrasadas: number
  hoje: number
  proximos7: number
  formatarValor: (valor: number) => string
  onAtrasadas: () => void
  onHoje: () => void
  onProximos7: () => void
}

export default function DashboardDueSummary({
  atrasadas,
  hoje,
  proximos7,
  formatarValor,
  onAtrasadas,
  onHoje,
  onProximos7,
}: Props) {
  const itens: ItemResumo[] = [
    { tipo: 'overdue', titulo: 'Atrasadas', apoio: 'pendências vencidas', valor: atrasadas, onClick: onAtrasadas },
    { tipo: 'today', titulo: 'Hoje', apoio: 'vence hoje', valor: hoje, onClick: onHoje },
    { tipo: 'next', titulo: 'Próximos 7 dias', apoio: 'a vencer', valor: proximos7, onClick: onProximos7 },
  ]

  return (
    <section className="dashboard-due-summary" aria-label="Agenda financeira">
      {itens.map(item => (
        <button
          key={item.tipo}
          type="button"
          className={`dashboard-due-card ${item.tipo} ${item.valor === 0 ? 'is-zero' : ''}`}
          onClick={item.onClick}
        >
          <span className="dashboard-due-icon" aria-hidden="true">
            {item.tipo === 'overdue' ? <CircleAlert size={18} /> : <CalendarClock size={18} />}
          </span>
          <span className="dashboard-due-copy">
            <strong>{item.titulo}</strong>
            <small>{item.apoio}</small>
          </span>
          <span className="dashboard-due-value privacy-value">{formatarValor(item.valor)}</span>
          <ChevronRight className="dashboard-due-chevron" size={16} aria-hidden="true" />
        </button>
      ))}
    </section>
  )
}
